/**
 * Flower vendor discriminators (mirrors API FlowerVendorIds).
 * Admin-only — never shown to end users in customer UX (PBI #1081).
 */
export const FlowerVendorIds = {
  FloristOne: 'floristone',
  Ftd: 'ftd',
} as const;

export type FlowerVendorId = (typeof FlowerVendorIds)[keyof typeof FlowerVendorIds];

/** Display labels for admin tables and filters. */
export const FLOWER_VENDOR_LABELS: Record<string, string> = {
  [FlowerVendorIds.FloristOne]: 'Florist One',
  [FlowerVendorIds.Ftd]: 'FTD',
};

/**
 * Returns a short admin label for a vendor id.
 */
export function formatFlowerVendorLabel(vendorId: string | null | undefined): string {
  if (!vendorId) return '--';
  return FLOWER_VENDOR_LABELS[vendorId] ?? vendorId;
}
